// extracted by mini-css-extract-plugin
export default {"button":"Button_button__NINxX","white":"Button_white__n0-cb","grey":"Button_grey__6tRaN"};